/* LV1: stamp the active market currency code onto app-rendered prices.
   Kaching Bundles deal bars + the UpCart checkout button (shadow DOM).
   Compare-at / crossed-out prices are deliberately left untouched. */
(function(){
  function code(){
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    var b = document.querySelector('kaching-bundles-block[config]');
    if (b) { try { var c = JSON.parse(b.getAttribute('config')); if (c && c.marketCurrencyCode) return c.marketCurrencyCode; } catch(e){} }
    return null;
  }

  function stamp(el, cc){
    if (!el) return;
    var txt = (el.textContent || '').trim();
    if (!txt || !/\d/.test(txt)) return;
    if (txt.slice(-4) === ' ' + cc) return;
    el.textContent = txt.replace(/\s+[A-Z]{3}$/, '') + ' ' + cc;
  }

  function run(){
    var cc = code();
    if (!cc) return;
    var bars = document.querySelectorAll('.kaching-bundles__bar-price');
    for (var i = 0; i < bars.length; i++) stamp(bars[i], cc);
    var host = document.getElementById('upCart');
    var sr = host && host.shadowRoot;
    if (sr) {
      var btns = sr.querySelectorAll('a.upcart-checkout-button, .upcart-checkout-button');
      for (var j = 0; j < btns.length; j++) stamp(btns[j], cc);
    }
  }

  function start(){
    run();
    // Observers cover instant reaction; the interval guarantees correctness even
    // when an app rebuilds its DOM (or its shadow root) out from under us.
    try { new MutationObserver(run).observe(document.body, { childList:true, subtree:true, characterData:true }); } catch(e){}
    setInterval(run, 700);
    [150,400,900,1600,3000].forEach(function(ms){ setTimeout(run, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
